import { SiteRoute } from '@journeyapps/package-types';
import styled from '@emotion/styled';
import * as React from 'react';
import { useEffect } from 'react';
import { Link } from 'react-router';
import { useIsPhoneSize } from '../../../hooks/useIsPhoneSize';
import { BREAKPOINT, DESKTOP_HEADER_PADDING, HEADER_GAP, IPAD_MEDIA, PAGE_PADDING, Z_INDEX } from '../../../vars';
import { LayoutClassName } from '../LayoutClassName';
import { DesktopHeaderWidget } from './DesktopHeaderWidget';
import { MobileDropdownMenu } from './MobileDropdownMenu';
import { MobileHeaderWidget } from './MobileHeaderWidget';

const logo = require('../../../../media/journeyapps-platform-logo.svg');

export interface HeaderWidgetProps {
  toggleTheme: () => any;
  dark: boolean;
}

export const HeaderWidget: React.FC<HeaderWidgetProps> = (props) => {
  const isPhone = useIsPhoneSize();
  const [collapsed, setCollapsed] = React.useState<boolean>(true);
  const [willCollapse, setWillCollapse] = React.useState<boolean>(false);

  const { dark, toggleTheme } = props;

  const closeMenu = React.useCallback(() => {
    setWillCollapse(() => true);
  }, []);

  const toggleMenu = React.useCallback(() => {
    if (collapsed) {
      setCollapsed(() => false);
      return;
    }

    closeMenu();
  }, [collapsed]);

  useEffect(() => {
    if (!isPhone) {
      setCollapsed(true);
    }
  }, [isPhone]);

  useEffect(() => {
    if (!willCollapse) {
      return;
    }

    const l = setTimeout(() => {
      setCollapsed(() => true);
    }, 250);

    return () => {
      clearTimeout(l);
    };
  }, [willCollapse]);

  useEffect(() => {
    setWillCollapse(() => false);
  }, [collapsed]);

  return (
    <S.Container className={LayoutClassName.HEADER}>
      <Link to={SiteRoute.HOMEPAGE}>
        <S.Logo src={logo} />
      </Link>
      {isPhone ? (
        <MobileHeaderWidget {...props} toggleMenu={toggleMenu} menuCollapsed={collapsed} />
      ) : (
        <DesktopHeaderWidget {...props} />
      )}
      {!collapsed && (
        <MobileDropdownMenu willCollapse={willCollapse} dark={dark} toggleTheme={toggleTheme} collapse={closeMenu} />
      )}
    </S.Container>
  );
};

namespace S {
  export const Container = styled.div`
    background: ${(p) => p.theme.header.background};
    backdrop-filter: blur(50px);
    width: 100%;
    height: ${(p) => p.theme.header.height}px;

    display: flex;
    align-items: center;
    gap: ${HEADER_GAP}px;

    padding-left: ${DESKTOP_HEADER_PADDING}px;
    padding-right: ${DESKTOP_HEADER_PADDING}px;
    z-index: ${Z_INDEX.HEADER};
    box-sizing: border-box;
    overflow: visible;
    position: sticky;

    @media (max-width: ${BREAKPOINT.DOCS_SIDEBARS}px) {
      padding-left: ${PAGE_PADDING}px;
      padding-right: ${PAGE_PADDING}px;
    }

    @media (max-width: ${IPAD_MEDIA}px) {
      padding-left: ${PAGE_PADDING}px;
      padding-right: ${PAGE_PADDING}px;
    }
  `;

  export const Logo = styled.img`
    height: 30px;
    filter: ${(p) => (p.theme.light ? 'invert()' : 'none')};
  `;
}
